<script setup>
// Shared "AI is auto-replying" strip (REQ-20260812-10). Visible to every
// agent who has the conversation open. There is no Stop button here —
// takeover is turning auto-reply off. Hidden when the switch is already off.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

const props = defineProps({
  conversationId: { type: [Number, String], required: true },
});

const { t } = useI18n();
const store = useStore();

const enabled = computed(() =>
  store.getters.counselAutoReplyFor(props.conversationId)
);
const busy = computed(() =>
  store.getters.counselAutoReplyBusyFor(props.conversationId)
);
const visible = computed(() => enabled.value && busy.value);
</script>

<template>
  <div
    v-if="visible"
    class="flex items-center gap-2 px-3 py-1.5 text-xs border-t border-n-weak bg-n-brand/10 text-n-brand"
    role="status"
  >
    <span class="inline-block rounded-full size-1.5 shrink-0 bg-n-brand animate-pulse" />
    <span class="font-medium">{{ t('CUSTOM.COUNSEL.AUTO_REPLY_BUSY') }}</span>
    <span class="text-n-slate-11">{{ t('CUSTOM.COUNSEL.AUTO_REPLY_BUSY_HINT') }}</span>
  </div>
</template>
